export default __webpack_public_path__ + "static/media/simcase_csv_template.550c59b4.csv";